// extracted by mini-css-extract-plugin
export default {"clickCollectCountdownContainer":"payment_clickCollectCountdownContainer__d3b75"};